/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BciCoreModule, BciLayoutModule, BciImprintComponent, LogoutComponent, BciSharedModule } from '@bci-web-core/core';
import { environment } from '../environments/environment';
import { EnvServiceProvider } from './env.service provider';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SettingsModule } from './settings/settings.module';
import { HomeModule } from './home/home.module';
import { AccountsModule } from './accounts/accounts.module';
import { TenantsModule } from './tenants/tenants.module';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from './shared/shared.module';
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { initializer } from './providers/app-init';
import { CanAuthenticationGuard } from './providers/auth-guard';
import { UsersModule } from './users/users.module';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DevicesModule } from './devices/devices.module';
import { ProfilesModule } from './profiles/profiles.module';
import { AuthInterceptor, AuthInterceptorIdToken } from './auth-interceptor';
import { FotaModule } from './fota/fota.module';
import { FirmwareModule } from './firmware/firmware.module';
import { SchedulerModule } from './scheduler/scheduler.module';
import { AccessKeysModule } from './access-keys/access-keys.module';
import { MaterialModule } from './shared/material.module';
import { IconModule } from './shared/icon.module';
import { ReportsModule } from './reports/reports.module';
import { CertificateModule } from './certificate/certificate.module';
import { BillingModule } from './billing/billing.module';
import { SmsModule } from './sms/sms.module';
import { SimModule } from './sim/sim.module';
import { WhatsappModule } from './whatsapp/whatsapp.module';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AgmCoreModule } from '@agm/core';
import { FotaAdvanceModule } from './fota-advance/fota-advance.module';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        KeycloakAngularModule,
        MatInputModule,
        SettingsModule,
        DevicesModule,
        HomeModule,
        AccountsModule,
        TenantsModule,
        UsersModule,
        AccessKeysModule,
        ProfilesModule,
        FotaModule,
        FirmwareModule,
        BrowserModule,
        SchedulerModule,
        ReportsModule,
        CertificateModule,
        BillingModule,
        SmsModule,
        SimModule,
        WhatsappModule,
        FotaAdvanceModule,
        AppRoutingModule,
        BciCoreModule.forRoot({ prod_environment: environment.production}),
        SharedModule,
        BrowserAnimationsModule,
        BciLayoutModule,
        BciSharedModule,
        MaterialModule,
        IconModule,
        NgxLinkifyjsModule.forRoot(),
        AgmCoreModule.forRoot({
            apiKey: window['__env'].googleMapKey,
            language: 'en',
            libraries: ['places','geometry','drawing']
          }),
       TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        {
            provide: MatDialogRef,
            useValue: {}
        },
        { provide: MAT_DIALOG_DATA, useValue: {} },
        EnvServiceProvider,
        {
            provide: APP_INITIALIZER,
            useFactory: initializer,
            multi: true,
            deps: [KeycloakService]
        },
        CanAuthenticationGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorIdToken,
            multi: true
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
